export const odluka_nadzor_osobnih= {
    templateId: 231,
    category: 3,
    templateTitle: 'Odluka o imenovanju osobe ovlaštene za nadzor u prikupljanju, obradi i korištenju osobnih podataka radnika',
    templateDescription: `<p>Poslodavac koji zapošljava najmanje dvadeset radnika dužan je imenovati osobu koja je osim njega ovlaštena nadzirati da li se osobni podaci prikupljaju, obrađuju, koriste i dostavljaju trećim osobama u skladu sa zakonom.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Zakon o radu obvezuje poslodavca koji zapošljava najmanje dvadeset radnika da imenuje osobu koja je osim njega ovlaštena nadzirati zakonsku usklađenost prikupljanja obradu, korištenja i dostave (trećima) osobnih podataka. </p>
    <p>Osobni podaci radnika smiju se prikupljati, obrađivati, koristiti i dostavljati trećim osobama samo ako je to određeno Zakonom o radu ili drugim zakonom ili ako je to potrebno radi ostvarivanja prava i obveza iz radnog odnosa, odnosno u vezi s radnim odnosom.</p>
    <p>Ako je osobne podatke radnika potrebno prikupljati, obrađivati, koristiti ili dostavljati trećim osobama radi ostvarivanja prava i obveza iz radnoga odnosa, odnosno u vezi s radnim odnosom, poslodavac mora unaprijed pravilnikom o radu odrediti koje će podatke u tu svrhu prikupljati, obrađivati, koristiti ili dostavljati trećim osobama.</p>
    <p>Navedene odredbe sadrži primjer Pravilnika o radu koji možete pogledati <a class="local-link" href="/contract?template=222">ovdje</a>.</p>
    <p>Osobne podatke radnika smije prikupljati, obrađivati, koristiti i dostavljati trećim osobama samo poslodavac ili osoba koju za to posebno opunomoći poslodavac.</p>
    <p>Poslodavac, imenovana osoba iz primjera odluke u nastavku ili druga osoba koja u obavljanju svojih poslova sazna osobne podatke radnika, te podatke trajno mora čuvati kao povjerljive.</p>
    <p>Sukladno Zakonu o radu, poslodavac kod kojega djeluje radničko vijeće ili sindikalni povjerenik dužan je ishoditi ovu <a class="local-link" href="/contract?template=77">suglasnost</a> na donošenje Odluke o imenovanju osobe ovlaštene za nadzor u prikupljanju, obradi i korištenju osobnih podataka radnika.</p>
    <p>Ovdje je važno naglasiti da se od 25. svibnja 2018. godine obrada osobnih podataka uređuje UREDBOM (EU) 2016/679 EUROPSKOG PARLAMENTA I VIJEĆA o zaštiti pojedinaca u vezi s obradom osobnih podataka i o slobodnom kretanju takvih podataka (Opća uredba o zaštiti podataka odnosno GDPR Uredba).</p>
    <p><strong>U tom smislu, spomenuta uredba, kao i sve uredbe EU ima opću primjenu i obvezujuća je u cijelosti te se neposredno primjenjuje, a moraju je u potpunosti poštovati oni na koje se odnosi.  U slučaju da je isto pitanje uređeno uredbom EU i normom nacionalnog zakonodavstva, odredbe uredbe EU imaju prednost u primjeni pred odredbama nacionalnog zakonodavstva.</strong><p>
    <p><strong>Ipak, svrha ove odluke je ispunjenje obveze Poslodavca iz Zakona o radu, koje su i dalje neizmijenjene. </strong><p>
      
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Neimenovanje osobe (u slučaju da poslodavac zapošljava najmanje dvadeset radnika) ovlaštene nadzirati prikupljaju li se, obrađuju, koriste i dostavljaju trećim osobama osobni podaci u skladu sa Zakonom o radu - prekršaj</strong></p>
    <p>Pojašnjenje: navedeno predstavlja prekršaj prema Zakonu o radu.</p>
  
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o radu.</p>
  `,
  sides: [
    {
      prefix: 'Na temelju Zakona o radu,',
      signature: 'Za Poslodavca:',
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: " (u daljnjem tekstu: Poslodavac),",
    }
  ],

  headline: 'donosi sljedeću',
  title: 'ODLUKU O IMENOVANJU OSOBE OVLAŠTENE ZA NADZOR U PRIKUPLJANJU, OBRADI I KORIŠTENJU OSOBNIH PODATAKA RADNIKA  ',

  noArticleNumbers: true,

  articles: [

    {
        title: '',
        mandatory: true,
        statements: [
          {
            type: 'input',
            mandatory: true,
            editable: false,
            parts: [
                { type: 'text', content: 'Radnik' },
                { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                { type: "text", content: "," },
                { type: 'text', content: 'iz',},
                { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                { type: 'text', content: ',' },
                { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                { type: "text", content: "," },
                { type: 'text', content: 'zaposlen na radnom mjestu' },
                { type: 'input', value: '', required: true, placeholder: "Naziv radnog mjesta"},
                { type: 'text', content: ', (u daljnjem tekstu: Radnik),'},
                { type: 'text', content: 'ovlašten je nadzirati da li se osobni podaci radnika prikupljaju, obrađuju, koriste i dostavljaju trećim osobama u skladu sa Zakonom o radu.' },
            ]
          }]
      },
      {
        title: '',
        mandatory: false,
        statements: [
          {
            type: 'text',
            mandatory: true,
            editable: true,
            content: 'Imenovana osoba iz ove odluke dužna je osobne podatke radnika koje sazna u obavljanju svojih poslova čuvati trajno kao povjerljive.'
          }]
      },
    {
      title: '------------------------------------------------------Obrazloženje------------------------------------------------------',
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: `Sukladno odredbama Zakona o radu, Poslodavac imenuje osobu koja je osim njega ovlaštena nadzirati prikupljaju li se, obrađuju, koriste i dostavljaju trećim osobama osobni podaci u skladu sa Zakonom o radu.`,
        }]
    },
    {
        title: '',
        mandatory: true,
        dummy: true,
        statements: [
          {
            type: 'text',
            mandatory: true,
            editable: true,
            content: `Kako imenovani radnik uživa povjerenje radnika, a u skladu s naprijed navedenim, odlučeno je kao u izreci ove Odluke.`,
          }]
      },
      {
        title: '',
        mandatory: false,
        dummy: true,
        statements: [
          {
            type: 'text',
            mandatory: true,
            editable: true,
            content: 'Ovo Odluka stupa na snagu danom donošenja.'
          }]
      },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signature
      statements: [],
    },
    {
      static: true,
      mandatory: false,
      type: 4, 
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska evidencija \r\n\r\nObavijest o odluci: Oglasna ploča',
          help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
        }
      ]
    },
  ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/231_odluka_nadzor_osobnih.ts